export const FETCH_LMS_SYLLABUSES_BY_ID_REQUEST = '@syllabuses/FETCH_BY_ID_REQUEST';
export const FETCH_LMS_SYLLABUSES_BY_ID_SUCCESS = '@syllabuses/FETCH_BY_ID_SUCCESS';
export const FETCH_LMS_SYLLABUSES_BY_ID_FAILURE = '@syllabuses/FETCH_BY_ID_FAILURE';
